import { createAsyncThunk } from "@reduxjs/toolkit";
import { addComment } from "../../../firebase/commentsApi";
import {
  adjustPendingCommentDeltas,
  incrementPostCommentCount,
} from "../postSlice.js";
import { fetchUsersByIds } from "../usersCacheSlice.js";

export const createComment = createAsyncThunk(
  "comments/createComment",
  async (
    { postId, comment, tempId },
    { rejectWithValue, dispatch, getState },
  ) => {
    dispatch(
      adjustPendingCommentDeltas({
        postId,
        commentCount: 1,
        topLevelCommentCount: 1,
      }),
    );
    try {
      const commentToCreate = {
        userId: comment.userId || null,
        username: comment.username,
        profession: comment.profession,
        photoURL: comment.photoURL,
        text: comment.text,
      };

      const serverComment = await addComment(postId, commentToCreate);

      dispatch(
        adjustPendingCommentDeltas({
          postId,
          commentCount: -1,
          topLevelCommentCount: -1,
        }),
      );
      dispatch(incrementPostCommentCount({ postId, delta: 1 }));

      // Prefetch user profile
      try {
        if (serverComment.userId) {
          dispatch(fetchUsersByIds({ userIds: [serverComment.userId] }));
        }
      } catch {}

      return { postId, comment: serverComment, tempId };
    } catch (error) {
      dispatch(
        adjustPendingCommentDeltas({
          postId,
          commentCount: -1,
          topLevelCommentCount: -1,
        }),
      );
      return rejectWithValue({
        message: error.message,
        code: error.code,
        tempId,
        postId,
      });
    }
  },
);
